import * as actionTypes from '../actionTypes/promotersTypes';
import axios from '../../axios-instance';
import {toast} from 'react-toastify';
import Swal from 'sweetalert2';
import { getHeaders } from "../../helpers/getHeaders";

const getPromotersStart = () => ({type: actionTypes.GET_PROMOTERS_START});
const getPromotersSuccess = events => ({type: actionTypes.GET_PROMOTERS_SUCCESS, payload: events});
const getPromotersFail = error => ({type: actionTypes.GET_PROMOTERS_FAIL, error});

export const getPromoters = (userToken, searchPromoterValue, skip, take) => dispatch => {
    dispatch(getPromotersStart());
    axios.get(`/Users?search=${searchPromoterValue}&skip=${skip}&take=${take}`, {headers: getHeaders(userToken)})
        .then(response => {
            if (response.data.isSuccess) {
                return response.data.result;
            }
            throw new Error(response.data.errorMessage);
        })
        .then(result => {
            dispatch(getPromotersSuccess(result));
        })
        .catch(err => {
            dispatch(getPromotersFail(err));
        })
};

const getPromoterStart = () => ({type: actionTypes.GET_PROMOTER_START});
const getPromoterSuccess = data => ({type: actionTypes.GET_PROMOTER_SUCCESS, payload: data});
const getPromoterFail = error => ({type: actionTypes.GET_PROMOTER_FAIL, error});

export const getPromoter = (userToken, promoterId) => dispatch => {
    dispatch(getPromoterStart());
    return axios.get(`/Users/${promoterId}`, {headers: getHeaders(userToken)})
        .then(response => {
            if (response.data.isSuccess) {
                return response.data.result;
            }
            throw new Error(response.data.errorMessage);
        })
        .then(result => {
            dispatch(getPromoterSuccess(result));
        })
        .catch(err => {
            Swal({
                title: "Error!",
                text: err,
                type: "error",
                timer: 3000
            });
            dispatch(getPromoterFail(err));
        })
};

const updatePromoterSuccess = data => ({type: actionTypes.UPDATE_PROMOTER_SUCCESS, payload: data});

export const updatePromoter = (userToken, promoterId, data) => dispatch => {
    dispatch(getPromoterStart());
    return axios.put(`/Users/${promoterId}`, data, {headers: getHeaders(userToken)})
        .then(response => {
            if (response.data.isSuccess) {
                toast.success("Promoter was successfully edited");
                dispatch(updatePromoterSuccess(response.data.result));
                return response.data.result;
            }
            throw new Error(response.data.errorMessage);
        })
        .catch(err => {
            toast.error("Promoter data not saved");
            dispatch(getPromoterFail(err));
        })
};

const setPromoterScanbitCostStart = () => ({type: actionTypes.SET_PROMOTER_SCANBIT_COST_START});
const setPromoterScanbitCostSuccess = () => ({type: actionTypes.SET_PROMOTER_SCANBIT_COST_SUCCESS});
const setPromoterScanbitCostFail = error => ({type: actionTypes.SET_PROMOTER_SCANBIT_COST_FAIL, error});

export const setPromoterScanbitCost = (userToken, promoterId, data) => dispatch => {
    dispatch(setPromoterScanbitCostStart());
    return axios.put(
        `/Users/${promoterId}`,
        data,
        {headers: getHeaders(userToken)}
        )
        .then(response => {
            if (response.data.isSuccess) {
                return response.data;
            }
            throw new Error(response.data.errorMessage);
        })
        .then(result => {
            dispatch(setPromoterScanbitCostSuccess(result));
            toast.success("Scanbit price was successfully changed");
            return result;
        })
        .catch(err => {
            Swal({
                title: "Error!",
                text: err,
                type: "error",
                timer: 3000
            });
            dispatch(setPromoterScanbitCostFail(err));
        })
};

const banPromoterStart = () => ({type: actionTypes.BAN_PROMOTER_START});
const banPromoterSuccess = () => ({type: actionTypes.BAN_PROMOTER_SUCCESS});
const banPromoterFail = () => ({type: actionTypes.BAN_PROMOTER_FAIL});

export const banPromoter = (userToken, promoterId, data) => dispatch => {
    dispatch(banPromoterStart());
    return axios.put(`/Users/${promoterId}`, data, {headers: getHeaders(userToken)})
        .then(response => {
            if (response.data.isSuccess) {
                return response.data;
            }
            throw new Error(response.data.errorMessage);
        })
        .then(result => {
            dispatch(banPromoterSuccess(result));
            return result;
        })
        .catch(err => {
            dispatch(banPromoterFail(err));
        })
};

const signInPromoterAsAdminStart = () => ({type: actionTypes.SIGN_IN_PROMOTER_AS_ADMIN_START});
const signInPromoterAsAdminSuccess = promoterAuthInfo => ({type: actionTypes.SIGN_IN_PROMOTER_AS_ADMIN_SUCCESS, payload: promoterAuthInfo});
const signInPromoterAsAdminFail = error => ({type: actionTypes.SIGN_IN_PROMOTER_AS_ADMIN_FAIL, error});

export const signInPromoterAsAdmin = (userToken, promoterId) => dispatch => {
    dispatch(signInPromoterAsAdminStart());
    return axios.post(`/Authorization/LoginPromoterAsSuperadmin?userId=${promoterId}`, {}, {headers: getHeaders(userToken)})
        .then(response => {
            if (response.data.isSuccess) {
                return response.data.result;
            }
            throw new Error(response.data.errorMessage);
        })
        .then(result => {
            dispatch(signInPromoterAsAdminSuccess(result));
            return result;
        })
        .catch(err => {
            dispatch(signInPromoterAsAdminFail(err));
        })
};

const getMapsStart = () => ({type: actionTypes.GET_MAPS_START});
const getMapsSuccess = data => ({type: actionTypes.GET_MAPS_SUCCESS, payload: data});
const getMapsFail = error => ({type: actionTypes.GET_MAPS_FAIL, error});

export const getMaps = (userToken, promoterId) => dispatch => {
  dispatch(getMapsStart());

  return axios.get(`/MapSeats/${promoterId}/Maps`, {headers: getHeaders(userToken)})
      .then(response => {
          if (response.data.isSuccess) {
            dispatch(getMapsSuccess(response.data.result));
              return response.data.result;
          }
          throw new Error(response.data.errorMessage);
      })
      .catch(err => {
          dispatch(getMapsFail(err));
          toast.error("Maps not received");
      })
};

const addMapSuccess = data => ({type: actionTypes.ADD_MAP_SUCCESS, payload: data});

export const addMap = (userToken, promoterId, data) => dispatch => {
  dispatch(getMapsStart());

  return axios.post(`/MapSeats/${promoterId}/Map`, data, {headers: getHeaders(userToken)})
      .then(response => {
          if (response.data.isSuccess) {
              dispatch(addMapSuccess(response.data.result));
              toast.success("Map successfully added");

              return response.data.result;
          }
          throw new Error(response.data.errorMessage);
      })
      .catch(err => {
          dispatch(getMapsFail(err));
          toast.error("Map not added");
      })
};

const updateMapSuccess = data => ({type: actionTypes.UPDATE_MAP_SUCCESS, payload: data});

export const updateMap = (userToken, promoterId, data) => dispatch => {
  dispatch(getMapsStart());

  return axios.put(`/MapSeats/${promoterId}/Map`, data, {headers: getHeaders(userToken)})
      .then(response => {
          if (response.data.isSuccess) {
              dispatch(updateMapSuccess(response.data.result));
              toast.success("Map successfully edited");

              return response.data.result;
          }
          throw new Error(response.data.errorMessage);
      })
      .catch(err => {
          dispatch(getMapsFail(err));
          toast.error("Map not edited");
      })
};

const getWorkspaceSuccess = data => ({type: actionTypes.GET_WORKSPACE_SUCCESS, payload: data});

export const getWorkspace = (userToken, promoterId) => dispatch => {
  dispatch(getMapsStart());

  return axios.get(`/MapSeats/${promoterId}/Workspace`, {headers: getHeaders(userToken)})
      .then(response => {
          if (response.data.isSuccess) {
              dispatch(getWorkspaceSuccess(response.data.result));

              return response.data.result;
          }
          throw new Error(response.data.errorMessage);
      })
      .catch(err => {
          dispatch(getMapsFail(err));
          toast.error("Workspace not received");
      })
};

const updateWorkspaceSuccess = data => ({type: actionTypes.UPDATE_WORKSPACE_SUCCESS, payload: data});

export const updateWorkspace = (userToken, promoterId, data) => dispatch => {
  dispatch(getMapsStart());

  return axios.put(`/MapSeats/${promoterId}/Workspace`, data, {headers: getHeaders(userToken)})
      .then(response => {
          if (response.data.isSuccess) {
            toast.success("Workspace successfully saved");
              return response.data.result;
          }
          
          throw new Error(response.data.errorMessage);
      })
      .then(result => {
          dispatch(updateWorkspaceSuccess(result));
      })
      .catch(err => {
          dispatch(getMapsFail(err));
          toast.error("Workspace not updated");
      })
};
